import { useCallback, useEffect, useState } from 'react';

import { ERRORS } from '../constants';
import { addCaptchaChallengeClass } from '../helpers';
import { useRecaptchaScale } from './useRecaptchaScale';
import { useValidateChallengeAnswer } from './useValidateChallengeAnswer';

export const useRenderRecaptcha = ({ onValidate, onError, operation, theme, size, tabIndex, captchaRef, language }) => {
    const [widgetId, setWidgetId] = useState();
    const recaptchaScale = useRecaptchaScale(captchaRef);
    const validateToken = useValidateChallengeAnswer({ onValidate, onError, operation, widgetId });

    // this is needed to handle the case when the reCAPTCHA challenge is initialized by Cloudflare
    // and the reCAPTCHA scale needs to be applied to the challenge container
    useEffect(() => {
        const handler = ({ data }) => {
            const { source, event } = data ?? {};

            if (source === 'cloudflare-challenge' && event === 'requestExtraParams') {
                recaptchaScale();
            }
        };

        window.addEventListener('message', handler);

        return () => window.removeEventListener('message', handler);
    }, [
        recaptchaScale
    ]);

    return useCallback((publicKey) => {
        const { grecaptcha } = window;

        if (widgetId != null) {
            grecaptcha.reset(widgetId);
        }

        const newWidgetId = grecaptcha.render(captchaRef.current, {
            size,
            theme,
            hl: language,
            tabindex: tabIndex,
            sitekey: publicKey,
            callback: token => validateToken({ token }),
            'error-callback': () => onError(ERRORS.RE_CAPTCHA_ANY_ERROR),
            'expired-callback': () => onError(ERRORS.RE_CAPTCHA_EXPIRATION_ERROR)
        });

        setWidgetId(newWidgetId);

        addCaptchaChallengeClass();
        recaptchaScale();
    }, [recaptchaScale, validateToken, onError, theme, size, tabIndex, captchaRef, widgetId, language]);
};
